import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {Subscription} from 'rxjs';
import {SessionQuery} from '../../../../../modules/authentication/session/session.query';
import {Roles, User} from '../../../../../modules/authentication/user/user.model';

@Directive({
  selector: '[authenticatedWithRole]'
})
export class AuthenticatedWithRoleDirective implements OnInit, OnDestroy {

  @Input() authenticatedWithRole: Roles[] | string[];
  userSubscription: Subscription;

  constructor(private el: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private sessionQuery: SessionQuery) {
  }

  ngOnInit() {
    this.viewContainer.clear();
    this.userSubscription = this.sessionQuery.getUserObservable().subscribe(user => {
      switch (true) {
        case (user && this.hasRole(user)):
          this.createView();
          break;
        case (user && this.authenticatedWithRole.includes('Any')):
          this.createView();
          break;
        case (!user && this.authenticatedWithRole.includes('Unauthenticated')):
          this.createView();
          break;
        default:
          this.viewContainer.clear();
          break;
      }
    });
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  createView() {
    if (this.viewContainer.length < 1) {
      this.viewContainer.createEmbeddedView(this.el);
    }
  }

  private hasRole(user: User): boolean {
    let matched = false;
    if (user.roles) {
      user.roles.forEach(role => {
        if (this.authenticatedWithRole.includes(role)) {
          matched = true;
        }
      });
    } else if (user.authorities) {
      user.authorities.forEach(role => {
        if (this.authenticatedWithRole.includes(role.name)) {
          matched = true;
        }
      });
    }

    return matched;
  }
}
